import type { BusinessFlow, BusinessFlowStep, ConceptEntity } from '@/types/knowledge_graph'
import { FlowStepRow } from '../components/FlowStepRow'

interface Props {
  flows: BusinessFlow[]
  entities?: ConceptEntity[]
  onUpdateStep: (businessFlowId: string, stepId: string, changes: Partial<BusinessFlowStep>) => void
}

export function BusinessFlowStepsView ({ flows, entities = [], onUpdateStep }: Props): React.ReactElement {
  if (flows.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--bp-ink3)', fontSize: 14 }}>
        業務フローがありません
      </div>
    )
  }

  return (
    <>
      {flows.map((flow) => {
        const normalSteps = flow.steps.filter((s) => s.step_type !== 'exception')
        const exceptionSteps = flow.steps.filter((s) => s.step_type === 'exception')
        return (
          <div key={flow.id} style={{ marginBottom: 24 }}>
            <div className='section-head'>
              <h3>{flow.name}</h3>
              {(flow.description != null && flow.description !== '') && <span className='count'>{flow.description}</span>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {normalSteps.length > 0 && (
                <>
                  <div style={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '.06em',
                    textTransform: 'uppercase',
                    color: 'var(--bp-ok)',
                    marginBottom: 4
                  }}
                  >
                    ▸ 正常系
                  </div>
                  {normalSteps.map((step, i) => (
                    <FlowStepRow
                      key={step.id}
                      step={step}
                      index={i + 1}
                      entities={entities}
                      onUpdate={(changes) => onUpdateStep(flow.id, step.id, changes)}
                    />
                  ))}
                </>
              )}
              {exceptionSteps.length > 0 && (
                <>
                  <div style={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '.06em',
                    textTransform: 'uppercase',
                    color: 'var(--bp-warning)',
                    margin: '16px 0 4px'
                  }}
                  >
                    ▸ 例外経路
                  </div>
                  {exceptionSteps.map((step, i) => (
                    <FlowStepRow
                      key={step.id}
                      step={step}
                      index={i + 1}
                      entities={entities}
                      isException
                      onUpdate={(changes) => onUpdateStep(flow.id, step.id, changes)}
                    />
                  ))}
                </>
              )}
            </div>
          </div>
        )
      })}
    </>
  )
}
